import {StylesConfig} from "react-select";
export interface SelectOption {
    value: string;
    label: string;
    fullLabel: string;
}
export const customStyles: StylesConfig<SelectOption, false> = {
    control: (provided, state) => ({
        ...provided,
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        borderRadius: '16px',
        backgroundColor: state.isDisabled ? "#E0E0E0 !important" : "#FFF !important",
        background: state.isDisabled ? "#E0E0E0 !important" : "#FFF !important",
        border: '1px solid',
        borderColor: state.isDisabled ? '#AFAFAF !important' : (state.menuIsOpen || state.hasValue) ? '#4C7FC8 !important' : '#AFAFAF !important',
        borderBottomColor: state.isDisabled ? '#AFAFAF !important' : (state.menuIsOpen || state.hasValue) ? '#4C7FC8 !important' : '#AFAFAF !important',
        outline: 'none',
        padding: '16px 24px',
        minHeight: '56px',
        zIndex: 8,
        boxShadow: 'none',
        opacity: state.isDisabled ? 0.6 : 1,
        filter: state.isDisabled ? 'blur(0.3px)' : 'none',
        '&:hover': {
            background: state.isDisabled ? "#E0E0E0 !important" : "#FFF !important"
        },
    }),
    option: (provided, state) => ({
        ...provided,
        padding: '0',
        backgroundColor: "#FFF",
        color: "#363636",
        cursor: 'pointer',
        position: 'relative',
        fontSize: '16px',
        lineHeight: '130%',
        fontWeight: state.isSelected ? 500 : 400,
        borderBottom: '1px solid #AFAFAF',
        paddingBottom: '12px',
        paddingTop: '12px',
        '&:hover': {
            backgroundColor: "#FFF"
        },
        '&:active': {
            backgroundColor: "#FFF"
        },
        '&:last-child': {
            borderBottom: 'none',
            paddingBottom: 0
        },
        '&:first-of-type': {
            borderTop: 'none',
            paddingTop: 0
        },
    }),
    // Стили для контейнера иконки
    dropdownIndicator: (provided, state) => ({
        ...provided,
        padding: '0',
    }),
    // Стили для выпадающего меню
    menu: (provided, state) => ({
        ...provided,
        border: '1px solid',
        borderColor: state.selectProps.menuIsOpen ? '#4C7FC8' : '#AFAFAF',
        borderTop: 'none',
        borderRadius: '0 0 16px 16px',
        boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.08)',
        marginTop: '4px',
        zIndex: 9,
        top: "38px",
        backgroundColor: "#FFF",
    }),
    // Стили для контейнера опций
    menuList: (provided) => ({
        ...provided,
        padding: '16px 24px',
        maxHeight: 'auto',
    }),
    // Стили для плейсхолдера
    placeholder: (provided, state) => ({
        ...provided,
        color: '#363636',
    }),
    // Стили для контейнера значений
    valueContainer: (provided) => ({
        ...provided,
        padding: '0',
        color: "#363636",
        backgroundColor: "#FFF !important",
        background: "#FFF !important",
    }),
    // Стили для контейнера значений
    singleValue: (provided, state) => ({
        ...provided,
        padding: '0',
        fontFamily: '"Onest","Roboto", "Helvetica", "Arial", sans-serif',
        color: state.isDisabled ? "#999" : "#363636",
        fontSize: '16px',
        fontWeight: 500,
        margin: 0,
        backgroundColor: state.isDisabled ? "#E0E0E0 !important" : "#FFF !important",
        background: state.isDisabled ? "#E0E0E0 !important" : "#FFF !important",
    }),
};
